module.exports = __webpack_public_path__ + "static/settings-1cdb36f66b4626a44505c7c285a8cb9f.png";